import { Popover as PopoverPrimitive } from '@base-ui/react/popover';
import { cn } from '@/shared/lib';
import type {
  PopoverContentProps,
  PopoverDescriptionProps,
  PopoverTitleProps,
} from '@/shared/ui/popover/types';
import { popoverStyles } from '@/shared/ui/popover/styles';

/**
 * The anchored popover surface: portal, positioner and popup.
 *
 * Popovers are frequently interactive, so unlike a tooltip this popup is not
 * restricted to text — it holds the controls that belong to it.
 */
export function PopoverContent({
  className,
  children,
  side,
  align,
  sideOffset,
  ...props
}: PopoverContentProps) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Positioner side={side} align={align} sideOffset={sideOffset}>
        <PopoverPrimitive.Popup className={cn(popoverStyles.popup, className)} {...props}>
          {children}
          <PopoverPrimitive.Arrow className={popoverStyles.arrow} />
        </PopoverPrimitive.Popup>
      </PopoverPrimitive.Positioner>
    </PopoverPrimitive.Portal>
  );
}

/** Accessible name for the popover surface. */
export function PopoverTitle({ className, ...props }: PopoverTitleProps) {
  return <PopoverPrimitive.Title className={cn(popoverStyles.title, className)} {...props} />;
}

/** Supplementary description beneath the popover title. */
export function PopoverDescription({ className, ...props }: PopoverDescriptionProps) {
  return (
    <PopoverPrimitive.Description
      className={cn(popoverStyles.description, className)}
      {...props}
    />
  );
}